export const Units_en = {
    bytes: 'Bytes',
    kb: 'KB',
    mb: 'MB',
    gb: 'GB',
    tb: 'TB',
    pb: 'PB',

    seconds_n: ':n second(s)',
    minutes_n: ':n minute(s)',
    hours_n: ':n hour(s)',
    days_n: ':n day(s)',
    weeks_n: ':n week(s)',

    // week_1: 'شنبه',
    // week_2: 'یکشنبه',
    // week_3: 'دوشنبه',
    // week_4: 'سه شنبه',
    // week_5: 'چهارشنبه',
    // week_6: 'پنج شنبه',
    // week_7: 'جمعه',


    // currency_iran_rial: 'ریال ایران',
    // currency_toman: 'تومان',
    // currency_us_dollar: 'دلار آمریکا',
    // currency_euro: 'یورو',
    // currency_indian_rupee: 'روپیه هند',
    // currency_pound: 'پوند',
    // currency_franc: 'فرانک',
    // currency_lira: 'لیره',
    // currency_dinar: 'دینار',

    // time_morning: 'صبح',
    // time_noon: 'ظهر',
    // time_evening: 'عصر',
    // time_night: 'شب',
}